module.exports = __webpack_public_path__ + "static/media/To_khai_Suc_khoe_UW03_20052024_latest_23052024.7ebe072e.pdf";